// extracted by mini-css-extract-plugin
module.exports = {"container":"blog-cards_container__mlTfn","horizontalScroll":"blog-cards_horizontalScroll__GepK5","column":"blog-cards_column__s4Hoo"};